export default __webpack_public_path__ + "static/media/purplepinata.15585d45.png";